export default {
  sm: `
  4차 산업혁명에 필요한 기술을 위해 방대한 데이터를
  쉽게 저장하고 빠르게 분석할 수 있는 기반을 
  제공합니다. 이로써 새로운 가치를 만들고 창의적인 
  혁신에 기여함으로써 삶을 더 편리하게 합니다.
  `,
  md: `
  4차 산업혁명에 필요한 기술을 위해 방대한
  데이터를 쉽게 저장하고 빠르게 분석할 수 있는 기반을 
  제공합니다. 이로써 새로운 가치를 만들고 창의적인 
  혁신에 기여함으로써 삶을 더 편리하게 합니다.
  `,
  lg: `
  4차 산업혁명에 필요한 기술을 위해 방대한 데이터를 쉽게
  저장하고 빠르게 분석할 수 있는 기반을 제공합니다.
  이로써 새로운 가치를 만들고 창의적인 혁신에 기여함으로써
  삶을 더 편리하게 합니다.
  `,
  xxl: `
  4차 산업혁명에 필요한 기술을 위해 방대한 데이터를
  쉽게 저장하고 빠르게 분석할 수 있는 기반을 제공합니다.
  이로써 새로운 가치를 만들고 창의적인 혁신에 기여함으로써
  삶을 더 편리하게 합니다.
  `
};
